import { Box, TextField } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";

export const IPInputCell = ({ value, onChange }) => {
    const parts = (value || "").split(".");
    const [ip, setIp] = useState([
        parts[0] || "",
        parts[1] || "",
        parts[2] || "",
        parts[3] || "",
    ]);

    const inputsRef = useRef([]);
    const ipRef = useRef(ip);

    const syncIpState = (nextIp) => {
        ipRef.current = nextIp;
        setIp(nextIp);
    };

    useEffect(() => {
        const nextParts = (value || "").split(".");
        syncIpState([
            nextParts[0] || "",
            nextParts[1] || "",
            nextParts[2] || "",
            nextParts[3] || "",
        ]);
    }, [value]);

    const emitIpValue = (ipParts) => {
        const hasAnyValue = ipParts.some((part) => part !== "");
        onChange(hasAnyValue ? ipParts.join(".") : "");
    };

    const handleChange = (index, val) => {
        // รับเฉพาะตัวเลข
        if (!/^\d*$/.test(val)) return;

        // ❌ ห้าม leading zero (ยกเว้น "0")
        if (val.length > 1 && val.startsWith("0")) return;

        // จำกัด 0-255
        if (val !== "" && Number(val) > 255) return;

        const newIp = [...ip];
        newIp[index] = val;
        syncIpState(newIp);

        // auto focus
        if (val.length === 3 && index < 3) {
            inputsRef.current[index + 1]?.focus();
        }

        // ครบ 4 octet
        if (newIp.every((p) => p !== "")) {
            emitIpValue(newIp);
        }
    };

    const handleContainerBlur = (e) => {
        if (e.currentTarget.contains(e.relatedTarget)) {
            return;
        }
        emitIpValue(ipRef.current);
    };

    const stopGridEvent = (e) => {
        e.stopPropagation();
    };

    return (
        <Box display="flex" alignItems="center" onBlur={handleContainerBlur}>
            {ip.map((part, index) => (
                <React.Fragment key={index}>
                    <TextField
                        value={part}
                        onChange={(e) => handleChange(index, e.target.value)}
                        inputRef={(el) => (inputsRef.current[index] = el)}
                        onMouseDown={stopGridEvent}
                        variant="standard"
                        inputProps={{
                            maxLength: 3,
                            style: {
                                width: 30,
                                textAlign: "center",
                                fontSize: 12,
                                padding: 2,
                            },
                        }}
                    />
                    {index < 3 && <span>.</span>}
                </React.Fragment>
            ))}
        </Box>
    );
};